/**
 *  ######################################
 *  ### DO NOT EDIT THIS FILE DIRECTLY ###
 *  ######################################
 *
 * This file is generated from:
 * /crates/mgo-open-rpc/spec/openrpc.json
 */

import type { GetTotalTransactionBlocksParams } from '@mgonetwork/mango.js/client';

import type { UseMgoClientQueryOptions } from '../useMgoClientQuery.js';
import { useMgoClientQuery } from '../useMgoClientQuery.js';

export function useTotalTransactionBlocks(
	params: GetTotalTransactionBlocksParams = {},
	options?: UseMgoClientQueryOptions<'getTotalTransactionBlocks'>,
) {
	return useMgoClientQuery(
		{
			method: 'getTotalTransactionBlocks',
			params,
		},
		options,
	);
}
